import React, { forwardRef } from 'react';

import type { ContentType, CustomCSSProperties } from '../types/pbTypes';

type PageBuilderElementWrapperProps = {
    contentType?: ContentType;
    uniqueID?: string;
    styles?: CustomCSSProperties;
    classNames?: string[];
    children: React.ReactNode;
    dataDesktopImg?: string;
    dataMobileImg?: string;
};

export const PageBuilderElementWrapper = forwardRef<HTMLDivElement, PageBuilderElementWrapperProps>((props, ref) => {
    return (
        <div
            ref={ref}
            data-content-type={props.contentType}
            aria-label={props.contentType}
            data-unique-id={props.uniqueID}
            key={props.uniqueID}
            id={props.uniqueID}
            style={props.styles}
            className={props.classNames?.join(' ')}
            data-desktop-img={props.dataDesktopImg}
            data-mobile-img={props.dataMobileImg}
        >
            {props.children}
        </div>
    );
});
